/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TmsMessageType {
  CreditCardTransactionSuccessful = 1,
  CreditCardPaidByChanged = 2,
  CreditCardReceivedOnChanged = 3,
  CreditCardAmountChanged = 4,
  CreditCardMemoChanged = 5,
  CreditCardClientIdChanged = 6,
  CreditCardValidationError = 7,
  ProcessCreditCardPayment = 8,
  CreditCardTransactionFailed = 9,
  RevenueCategoryAddNew = 10,
  RevenueCategoryEditCategory = 11,
  RevenueCategoryCancelAddEdit = 12,
  RevenueCategorySaved = 13,
  EditPackagePlan = 14,
  PackagePlanAddEditCloseSideModal = 15,
  SellPackagePlanCloseSideModal = 16,
  StaffCheckInNavigateToClientProfile = 17,
  GroupsHideRegisterMember = 18,
  GroupsShowRegisterMember = 19,
  GroupsShowRegisterMemberHideModal = 20,
  ClientMergeComplete = 21,
  ScheduleEzView = 22,
  ScheduleDatebook = 23,
  IframeResize = 24,
  MembershipEditCloseSideModal = 25,
  MembershipShareCloseSideModal = 26,
  ClientBillingOpenSellItemSideModal = 27,
  ClientBillingCloseSellItemSideModal = 28,
  ClientPackageCloseEditClientPackageSideModal = 29,
  ClientPackageCloseUpdateAttendanceSideModal = 30,
  ClientPackageCloseSessionClassesSideModal = 31,
  CloseOneInvoiceSideModal = 32,
  GenerateIdCardResponse = 33,
  GotoClientDetails = 34,
  SelfCheckinSettingsSaved = 35,
  GroupsGotoGroup = 36,
  GroupsRefresh = 37,
  SellPackagePlanShowSideModal = 38,
  TaxAdded = 39,
  ClientDetailTotalsUpdate = 40,
  ClientMembershipUpdate = 41,
  SendClientEmail = 42,
  CloseEmailClientSideModal = 43,
  EquipmentAddEditShowSideModal = 44,
  EquipmentAddEditCloseSideModal = 45,
  EquipmentCategoryChanged = 46,
  ZoomAuthenticationUrl = 47,
  UpdateSessionData = 48,
  ReportFinished = 49,
}
